import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <section className="py-10 lg:py-20 px-4 sm:px-6 lg:px-8 bg-off-white" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        <div className="text-center mb-8 lg:mb-16" data-id="element-120">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-charcoal mb-2 lg:mb-4" data-id="element-121">
            Para quién es esta guía
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8" data-id="element-122">
          {/* YES Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-5 lg:p-8 rounded-2xl shadow-sm border-t-4 border-green-500" data-id="element-123">
            <h3 className="text-lg lg:text-xl font-bold text-charcoal mb-4 lg:mb-6 flex items-center" data-id="element-124">
              <span className="bg-green-100 text-green-700 py-1 px-3 rounded-full text-sm font-bold mr-3" data-id="element-125">
                SÍ
              </span>
              Es para ti si...
            </h3>
            <ul className="space-y-3 lg:space-y-4" data-id="element-126">
              {['Es tu primera vez en China y quieres hacerlo bien', 'Te da pánico perderte o no poder pagar', 'Te gusta viajar cómodo y práctico', 'Quieres un plan flexible sin volverte loco'].map((item, i) => <li key={i} className="flex items-start" data-id="element-127">
                  <Check className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-128" />
                  <span className="text-charcoal-light" data-id="element-129">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-5 lg:p-8 rounded-2xl shadow-sm border-t-4 border-red-400" data-id="element-130">
            <h3 className="text-lg lg:text-xl font-bold text-charcoal mb-4 lg:mb-6 flex items-center" data-id="element-131">
              <span className="bg-red-100 text-red-700 py-1 px-3 rounded-full text-sm font-bold mr-3" data-id="element-132">
                NO
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-3 lg:space-y-4" data-id="element-133">
              {['Quieres un tour organizado con guía 24/7', 'Prefieres improvisar cada día sin estructura', 'Buscas una guía "de fotos bonitas" sin parte operativa'].map((item, i) => <li key={i} className="flex items-start" data-id="element-134">
                  <X className="h-5 w-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-135" />
                  <span className="text-charcoal-light" data-id="element-136">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}